import { CRMUser, CRMUsersQueryParams, CreateCRMUserRequest, CursorPaginatedResponse } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

export class CRMUsersAPI {
  static async getCRMUsers(orgId: number, params: CRMUsersQueryParams = {}): Promise<CursorPaginatedResponse<CRMUser>> {
    const searchParams = new URLSearchParams();

    if (params.locationId !== undefined) {
      searchParams.append("locationId", String(params.locationId));
    }
    if (params.groupId !== undefined) {
      searchParams.append("groupId", String(params.groupId));
    }
    if (params.customerType && params.customerType.length > 0) {
      params.customerType.forEach((s) => searchParams.append("customerType", s));
    }
    if (params.hasBalance !== undefined) {
      searchParams.append("hasBalance", String(params.hasBalance));
    }
    if (params.hasAutopay !== undefined) {
      searchParams.append("hasAutopay", String(params.hasAutopay));
    }
    if (params.status && params.status.length > 0) {
      params.status.forEach((s) => searchParams.append("status", s));
    }
    if (params.after !== undefined) {
      searchParams.append("after", String(params.after));
    }
    if (params.before !== undefined) {
      searchParams.append("before", String(params.before));
    }
    if (params.limit !== undefined) {
      searchParams.append("limit", String(params.limit));
    }
    if (params.sort) {
      searchParams.append("sort", params.sort);
    }
    if (params.search !== undefined) {
      searchParams.append("search", String(params.search));
    }
    if (params.include) {
      searchParams.append("include", params.include);
    }

    const queryString = searchParams.toString();
    const url = `/crm/org/${orgId}/users${queryString ? `?${queryString}` : ""}`;

    return APIService.Server.get<CursorPaginatedResponse<CRMUser>>(url);
  }

  static async createCRMUser(orgId: number, body: CreateCRMUserRequest) {
    return APIService.Server.post<CRMUser>(`/crm/org/${orgId}/users`, body);
  }

  static async getCRMUserById(orgId: number, userId: number, include?: string): Promise<CRMUser> {
    const params = include ? `?include=${encodeURIComponent(include)}` : "";
    return APIService.Server.get<CRMUser>(`/crm/org/${orgId}/users/${userId}${params}`);
  }
}
